import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AuthGuard from "./components/AuthGuard";
import HomeLayout from "./components/HomeLayout";
import LoginPage from "./pages/Login";
import ApiDebugPage from "./pages/ApiDebug";
import Console from "./pages/Console";

const App: React.FC = () => {
	return (
		<Router>
			<div className="app-container">
				<Switch>
					<Route path="/login" component={LoginPage} />
					<Route
						path="/interface-debug"
						render={() => (
							<AuthGuard>
								<ApiDebugPage />
							</AuthGuard>
						)}
					/>
					<Route
						path="/console"
						render={() => (
							<AuthGuard>
								<Console />
							</AuthGuard>
						)}
					/>
					<Route
						path="/"
						render={() => (
							// <AuthGuard requireAuth={false}>
							<HomeLayout />
							// </AuthGuard>
						)}
					/>
				</Switch>
			</div>
		</Router>
	);
};

export default App;
